<template>
  <div>
    <a-layout id="components-layout-demo-fixed">
      <a-layout-header :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
        <div class="logo" :style="{width: logoWidth}">
          <img class="logo-img" :style="{display : logoTitle}" src="../assets/52-04.png">
          <img class="logo-img-mobile" :style="{display : mobileLogo}" src="../assets/52.png">
<!--          <img class="logo-title" :style="{display : logoTitle}" src="../assets/title.png">-->
        </div>
        <a-menu
          theme="light"
          mode="horizontal"
          :defaultSelectedKeys="['1']"
          :style="{ lineHeight: '64px' }"
        >
          <a-menu-item v-if="isShowMyBook&!showMenu" key="1" class="medium-li">
            <router-link v-bind:to="{name: 'book-card'}">我的书</router-link>
          </a-menu-item>
<!--          <a-menu-item key="2">-->
<!--            <router-link v-bind:to="{name: 'week-report'}">周报</router-link>-->
<!--          </a-menu-item>-->
          <a-menu-item key="2" v-if="!showMenu" class="medium-li">
            <router-link v-bind:to="{name: 'class-overview'}">课堂回顾</router-link>
          </a-menu-item>
          <a-menu-item key="7" v-if="!showMenu&(hasAdminRole || hasTeacherRole)" class="medium-li">
            <router-link v-bind:to="{name: 'homework'}">查询</router-link>
          </a-menu-item>
          <a-menu-item key="3" v-if="showMenu&hasVolunteerRole " class="small-li">
            <router-link v-bind:to="{name: 'volunteer-manage'}">志愿者</router-link>
          </a-menu-item>
          <a-menu-item key="4" v-if="showMenu&hasAdminRole " class="small-li">
            <router-link v-bind:to="{name: 'user-manage'}">用户管理</router-link>
          </a-menu-item>
          <a-menu-item key="5" v-if="showMenu&hasTeacherRole" class="small-li">
            <router-link v-bind:to="{name: 'process'}">标准流程</router-link>
          </a-menu-item>
          <a-menu-item key="6" v-if="showMenu&hasTeacherRole" class="small-li">
            <router-link v-bind:to="{name: 'reading-plan-manage'}">计划管理</router-link>
          </a-menu-item>
<!--          <a-menu-item key="5" v-if="showMenu">-->
<!--            <router-link v-bind:to="{name: 'volunteer-detail'}">志愿者详情</router-link>-->
<!--          </a-menu-item>-->
<!--          <a-menu-item key="4">-->
<!--            <router-link v-bind:to="{name: 'image'}">image</router-link>-->
<!--          </a-menu-item>-->
<!--          <a-menu-item key="5">-->
<!--            <router-link v-bind:to="{name: 'bookcase'}">书柜</router-link>-->
<!--          </a-menu-item>-->

          <a-sub-menu class="user-info">
            <span slot="title" class="submenu-title-wrapper">
              <a-avatar shape="circle" size="large"
                        :style="{backgroundColor: color, verticalAlign: 'middle'}">
                {{name}}
              </a-avatar>
            </span>
              <a-menu-item v-if="(!showMenu)&hasVolunteerRole"
                           @click="gotoVolunteer" key="setting:1"> 志愿者 </a-menu-item>
              <a-menu-item v-if="(!showMenu)&hasAdminRole"
                         @click="gotoUserManage" key="setting:2"> 用户管理 </a-menu-item>
             <a-menu-item v-if="(!showMenu)&hasAdminRole"
                         @click="gotoReadingPlanManage" key="setting:3"> 计划管理 </a-menu-item>
              <a-menu-item v-if="showMenu" @click="gotoBook" key="setting:4"> 我的书 </a-menu-item>
              <a-menu-item v-if="(!showMenu)&hasTeacherRole"
                           @click="gotoProcess" key="setting:5"> 标准流程 </a-menu-item>
              <a-menu-item @click="gotoReset" key="setting:6"> 修改密码 </a-menu-item>
              <a-menu-item @click="logout" key="setting:7">退出登录</a-menu-item>
          </a-sub-menu>

        </a-menu>
      </a-layout-header>
      <a-layout-content :style="{ padding: contentPadding, marginTop: contentMarginTop }">
        <a-breadcrumb :style="{ margin: '16px 0' }">
<!--          <a-breadcrumb-item>Home</a-breadcrumb-item>-->
<!--          <a-breadcrumb-item>List</a-breadcrumb-item>-->
<!--          <a-breadcrumb-item>App</a-breadcrumb-item>-->
        </a-breadcrumb>
        <div :style="{ background: '#fff', padding: routerViewPadding,
        minHeight: '810px',clear: 'both' }">
          <router-view />
          <div class="clear"></div>
        </div>
      </a-layout-content>
      <a-layout-footer :style="{ textAlign: 'center' }">
        <div>
          <span><img class="bottom-logo-img" src="../assets/shutan.png"></span>
<!--          <span><img class="bottom-logo-title"  src="../assets/title.png"></span>-->
        </div>
        <a href="https://beian.miit.gov.cn/" target="_blank" style="color:rgba(0, 0, 0, 0.65)">沪ICP备19027057号</a>
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
import store from '../store';

export default {
  name: 'Layout',
  store,
  data() {
    return {
      collapsed: false,
      logoTitle: 'inline',
      mobileLogo: 'none',
      logoWidth: '100px',
      contentPadding: '0 20px',
      contentMarginTop: '64px',
      routerViewPadding: '24px',
      color: '#00a2ae',
      name: '',
      showMenu: false,
      hasVolunteerRole: false,
      hasTeacherRole: false,
      hasAdminRole: false,
    };
  },
  created() {
    this.changeUserName();
    this.changeLogoPosition();
    this.showMenu = store.state.showMenu;
    this.hasVolunteerRole = store.state.user.roles.indexOf('VADMIN') > -1;
    this.hasAdminRole = store.state.user.roles.indexOf('ADMIN') > -1;
    this.hasTeacherRole = store.state.user.roles.indexOf('TEACHER') > -1;
  },
  computed: {
    isShowMyBook() {
      return store.state.showMyBook;
    },
  },
  methods: {
    gotoReset() {
      this.$router.push('/reset/password');
    },
    async logout() {
      this.axios.get('/service/logout').then((response) => {
        if (response.data.code === 0) {
          store.state.user.userId = null;
          store.state.showMenu = false;
          if (window.localStorage) {
            localStorage.removeItem('userInfo');
          }
          this.$message.success('退出成功', 2);
          this.$router.push('/');
        } else {
          this.$message.error('初始化失败！');
        }
      }).catch(() => {
        store.state.user.userId = null;
        this.$message.success('退出成功', 2);
        if (window.localStorage) {
          localStorage.removeItem('userInfo');
        }
        this.$router.push('/');
      });
    },
    gotoVolunteer() {
      store.state.showMenu = true;
      this.showMenu = true;
      this.$router.push('/layout/volunteer-manage');
    },
    gotoUserManage() {
      store.state.showMenu = true;
      this.showMenu = true;
      this.$router.push('/layout/user-manage');
    },
    gotoReadingPlanManage() {
      store.state.showMenu = true;
      this.showMenu = true;
      this.$router.push('/layout/reading-plan-manage');
    },
    gotoBook() {
      store.state.showMenu = false;
      this.showMenu = false;
      this.$router.push('/layout/book-card');
    },
    gotoProcess() {
      store.state.showMenu = true;
      this.showMenu = true;
      this.$router.push('/layout/process');
    },
    changeLogoPosition() {
      // if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      //   this.logoTitle = 'none';
      //   this.logoWidth = '30px';
      // }
      console.log(store.state.user.roles[0]);
      console.log(store.state.user.roles.indexOf('VADMIN') > -1);
      if (this.isMobile()) {
        this.logoTitle = 'none';
        this.logoWidth = '30px';
        this.contentPadding = '0';
        this.contentMarginTop = '58px';
        this.routerViewPadding = '15px';
        this.mobileLogo = 'inline';
      }
    },
    changeUserName() {
      console.log(store.state.user);
      const tempName = store.state.user.name;
      if (typeof (tempName) === 'undefined' || tempName === null) {
        // this.$message.error('登录过期', 2);
        this.$router.push('/');
        store.state.user.userId = null;
        return;
      }
      this.name = store.state.user.name.substr(tempName.length - 1, tempName.length);
    },
  },
};
</script>

<style scoped>
  #components-layout-demo-fixed .logo {
    width: 120px;
    height: 31px;
    background: rgba(255,255,255,.2);
    margin: 6px 24px 16px 0;
    float: left;
  }
  .ant-layout-header {
    background: #ffffff;
    padding: 0;
  }
  .clear{
    clear: both;
  }
  .bottom-logo-img {
    width: 100px;
    /*height: 30px;*/
    /*border-radius: 30px;*/
    margin-bottom: 5px;
  }
  .bottom-logo-title {
    margin-left: 1px;
    width: 60px;
    margin-bottom: -5px;
  }
  .logo-img {
    width: 80px;
    /*height: 30px;*/
    /*border-radius: 30px;*/
    margin-top: -15px;
    margin-left: 20px;
  }
  .logo-title{
    height: 24px;
    margin-top: -158px;
    margin-left: 55px;
    display: none;
  }
  /*导航栏激活状态*/
  .ant-menu-horizontal >.ant-menu-item-selected {
    color:  rgba(0, 0, 0, 0.65) !important;
    border-bottom: 2px solid transparent;
  }

.ant-menu-horizontal > .ant-menu-item-selected > a {
  color:  rgba(0, 0, 0, 0.65)
}
  .active {
    position: relative;
    top: 2px;
    color: #1890ff !important;
    border-bottom: 2px solid #1890ff;
  }
  .ant-card-cover{
    border-bottom: 10px solid grey;
  }
  .ant-card-body {
    border-top: 1px solid grey;
  }
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 16px 5px !important;
  }
  .ant-menu-submenu-content {
    margin-left: -30px;
  }
  .user-info {
    border-bottom: 0 !important;
    color: #1890ff;
    position: absolute;
    top: 1px;
    right: -2px;
    float: right;
    display: inline !important;
  }
  .logo-img-mobile{
    width: 40px;
    margin-top: -10px;
    margin-left: 15px;
  }
  .small-li {
    padding: 0 6px;
  }
  .medium-li {
    padding: 0 10px;
  }
</style>
